function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.89893 8.11914C9.23926 8.11914 9.54639 7.96143 9.90332 7.60449L16.7598 0.789551C16.4526 0.515625 15.9048 0.382812 15.1411 0.382812H2.46582C1.79346 0.382812 1.30371 0.507324 1.01318 0.756348L7.90283 7.60449C8.25146 7.95312 8.55859 8.11914 8.89893 8.11914ZM0.224609 12.9419L5.91064 7.28906L0.241211 1.70264C0.0834961 1.95996 0.000488281 2.3916 0.000488281 2.99756V11.6802C0.000488281 12.2695 0.0751953 12.6846 0.224609 12.9419ZM17.5732 12.9253C17.7061 12.6763 17.7808 12.2612 17.7808 11.6802V2.99756C17.7808 2.4082 17.6978 1.97656 17.5483 1.71924L11.8955 7.28906L17.5732 12.9253ZM2.64014 14.3032H15.3154C16.021 14.3032 16.519 14.1621 16.8179 13.8965L11.0239 8.14404L10.5591 8.60889C10.0112 9.14014 9.48828 9.38916 8.89893 9.38916C8.31787 9.38916 7.78662 9.14014 7.23877 8.60889L6.77393 8.14404L0.988281 13.8882C1.31201 14.1621 1.86816 14.3032 2.64014 14.3032Z",
  fill: "#5F8BFC"
});

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email.8cbe38cb.svg";
export { ForwardRef as ReactComponent };